<template>
  <span class="w-full text-center text-foreground font-heading text-xs leading-4 font-medium md:text-lg md:leading-6">
    <slot />
  </span>
</template>
